import { c as _c } from "react/compiler-runtime";
import React, { useContext, useEffect, useRef } from "react";
import { GoogleAnalytics } from "../GoogleAnalytics";
import { GoogleTagManager } from "../GoogleTagManager";
import styles from "./CookieBanner.module.scss";
import { LinkComponent } from "../../../main/blocks/Links/Links";
import { HotJar } from "../HotJar";
import { ConsentState } from "../../../../proxy.page";
import { setCookie } from "cookies-next/client";
import { BannerContext } from "../../../main/layout/layout";
import { MetaPixel } from "../MetaPixel";
import { CookieBannerQueryResult } from "../../../../studio/sanity.types";
import { useTrackingEnabled } from "../../../../hooks/useTrackingEnabled";
export const CookieBanner: React.FC<{
  configuration: CookieBannerQueryResult;
}> = t0 => {
  const $ = _c(26);
  const {
    configuration
  } = t0;
  const [bannerContext, setBannerContext] = useContext(BannerContext);
  const tracking = useTrackingEnabled();
  const bannerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const root = document.documentElement;
      const element = bannerRef.current;
      if (!element) {
        root.style.setProperty("--cookie-banner-height", "0px");
        return;
      }
      const updateHeight = () => {
        root.style.setProperty("--cookie-banner-height", `${element.offsetHeight}px`);
      };
      updateHeight();
      const observer = new ResizeObserver(updateHeight);
      observer.observe(element);
      return () => {
        observer.disconnect();
        root.style.setProperty("--cookie-banner-height", "0px");
      };
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== bannerContext.consentState) {
    t2 = [bannerContext.consentState];
    $[1] = bannerContext.consentState;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!configuration) {
    return null;
  }
  const gaMeasurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
  const gtmId = process.env.NEXT_PUBLIC_GTM_ID;
  const hotjarId = process.env.NEXT_PUBLIC_HOTJAR_ID;
  const metaPixelId = process.env.NEXT_PUBLIC_META_PIXEL_ID;
  const expiredTemplate = configuration.expired_template || "Last updated {date}";
  let t3;
  if ($[3] !== setBannerContext) {
    t3 = state => {
      setCookie("gieffektivt-cookies-accepted", state === "accepted" ? "true" : "false", {
        sameSite: "lax",
        expires: new Date(new Date().getTime() + 31536000000)
      });
      setBannerContext(prev => ({
        ...prev,
        consentState: state
      }));
    };
    $[3] = setBannerContext;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setConsent = t3;
  let privacyPolicyLink = configuration.privacy_policy_link;
  if (bannerContext.consentExpired && bannerContext.privacyPolicyLastMajorChange && configuration.privacy_policy_link) {
    const t4 = configuration.privacy_policy_link;
    const t5 = configuration.privacy_policy_link.title;
    let t6;
    if ($[5] !== bannerContext.privacyPolicyLastMajorChange || $[6] !== expiredTemplate) {
      t6 = expiredTemplate.replace("{date}", bannerContext.privacyPolicyLastMajorChange.toLocaleDateString("no-NB"));
      $[5] = bannerContext.privacyPolicyLastMajorChange;
      $[6] = expiredTemplate;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    const t7 = `${t5} ${t6}`;
    let t8;
    if ($[8] !== configuration.privacy_policy_link || $[9] !== t7) {
      t8 = {
        ...t4,
        title: t7
      };
      $[8] = configuration.privacy_policy_link;
      $[9] = t7;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    privacyPolicyLink = t8;
  }
  let t4;
  if ($[11] !== bannerContext.consentExpired || $[12] !== bannerContext.consentState || $[13] !== tracking) {
    t4 = bannerContext.consentState === "accepted" && !bannerContext.consentExpired && tracking && <>{gtmId ? <GoogleTagManager gtmId={gtmId} /> : null}{gaMeasurementId ? <GoogleAnalytics gaMeasurementId={gaMeasurementId} /> : null}{hotjarId ? <HotJar hotjarId={hotjarId} /> : null}{metaPixelId ? <MetaPixel pixelId={metaPixelId} /> : null}</>;
    $[11] = bannerContext.consentExpired;
    $[12] = bannerContext.consentState;
    $[13] = tracking;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== bannerContext.consentState || $[16] !== configuration.accept_button_text || $[17] !== configuration.decline_button_text || $[18] !== configuration.description || $[19] !== configuration.title || $[20] !== privacyPolicyLink || $[21] !== setConsent) {
    t5 = bannerContext.consentState === "undecided" && <div data-cy="cookiebanner-container" className={styles.container} ref={bannerRef}><div className={styles.content}><div className={styles.description}><span className={styles.title}>{configuration.title}</span><p>{configuration.description}</p></div><div className={styles.buttonsWrapper}>{privacyPolicyLink && <LinkComponent link={privacyPolicyLink} style={{
            border: "none"
          }} />}<div className={styles.buttons}><button data-cy="decline-cookies" onClick={() => {
              setConsent("rejected" as ConsentState);
            }} style={{
              marginRight: "2rem"
            }}>{configuration.decline_button_text}</button><button data-cy="accept-cookies" onClick={() => {
              setConsent("accepted" as ConsentState);
            }}>{configuration.accept_button_text}</button></div></div></div></div>;
    $[15] = bannerContext.consentState;
    $[16] = configuration.accept_button_text;
    $[17] = configuration.decline_button_text;
    $[18] = configuration.description;
    $[19] = configuration.title;
    $[20] = privacyPolicyLink;
    $[21] = setConsent;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t4 || $[24] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
};